export const FETAL_HEART_RATE_ROOT_LINK_ID = "fetalHeartRate";

export const FETAL_HEART_RATE_DATE_TIME_LINK_ID = "fhrDateTime";
export const FETAL_HEART_RATE_DATE_LINK_ID = "fhrDate";
export const FETAL_HEART_RATE_TIME_LINK_ID = "fhrTime";

export const FETAL_HEART_RATE_BEATS_PER_MINUTE_LINK_ID = "fhrBPM";
export const FETAL_HEART_RATE_BEATS_PER_MINUTE_LOW_LINK_ID = "fhrBPMLow";
export const FETAL_HEART_RATE_BEATS_PER_MINUTE_HIGH_LINK_ID = "fhrBPMHigh";

export const FETAL_HEART_RATE_DURATION_OF_LISTENING_LINK_ID = "fhrDurationOfListening";
export const FETAL_HEART_RATE_LISTENING_DEVICE_LINK_ID = "fhrListeningDevice";
export const FETAL_HEART_RATE_RELATION_TO_CONTRACTIONS_LINK_ID = "fhrRelationToContractions";

export const FETAL_HEART_RATE_ACCELERATIONS_DETECTED_LINK_ID = "accelerationsDetected";
export const FETAL_HEART_RATE_DECELERATIONS_DETECTED_LINK_ID = "decelerationsDetected";
export const FETAL_HEART_RATE_ASSESS_BASELINE_LINK_ID = "assessBaseline";

export const FETAL_HEART_RATE_BASELINE_LINK_ID = "fhrBaseline";
export const FETAL_HEART_RATE_BASELINE_DURATION_OF_LISTENING_LINK_ID = "fhrDurationOfListeningFHT";
export const FETAL_HEART_RATE_NOTES_LINK_ID = "fhrNotes";
export const FETAL_HEART_RATE_SIGNATURE_INITIALS_LINK_ID = "fhrSignatureInitials";

export const FETAL_HEART_RATE_QUESTIONNAIRE_NAME = "fetal_heart_rate";
